var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2154_19244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1554 0.315186L0.628296 3.71261L2.08141 16.3097L10.1554 20.7816L18.2294 16.3097L19.6825 3.71261L10.1554 0.315186Z",
    fill: "#DD0031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.158 0.315186V2.58696V2.57672V12.943V20.7816L18.232 16.3097L19.6851 3.71261L10.158 0.315186Z",
    fill: "#C3002F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1519 2.57666L4.19617 15.931H6.41677L7.61405 12.9429H12.6693L13.8665 15.931H16.0871L10.1519 2.57666ZM11.8915 11.1009H8.41224L10.1519 6.91554L11.8915 11.1009Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2154_19244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.0542,
    height: 20.4664,
    fill: "white",
    transform: "translate(0.637695 0.314575)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.355287b150d552863be88f4c2ef2053c.svg";
export { ForwardRef as ReactComponent };